module.exports = __webpack_public_path__ + "img/headerLogo.782d7f9f.png";